const baseUrl =
	"https://pidasaaristosiistina-kartta.fi-p.seravo.com/wp-json/pss_map/v1";

export default baseUrl;
